const LEGACY_LANGUAGE_COOKIE_MAP = {
    en: 'english-united-states',
    es: 'spanish-international',
};

const getCookie = (name) => {
    const cookie = document.cookie
        .split('; ')
        .find((item) => item.startsWith(`${name}=`));

    return cookie ? decodeURIComponent(cookie.split('=').slice(1).join('=')) : '';
};

export const getGatewayLanguagePreference = (languages = []) => {
    const gatewayLanguage = getCookie('gateway-language');
    const legacyIntl = getCookie('gateway-intl');
    const preferredCode = gatewayLanguage || LEGACY_LANGUAGE_COOKIE_MAP[legacyIntl];

    if (!preferredCode) return null;

    return (
        languages.find((language) => language.value === preferredCode || language.code === preferredCode) ||
        null
    );
};
